import { Component, OnInit } from '@angular/core';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { FichaValoracionClienteComponent } from 'src/app/home/valoracion-clientes/ficha-valoracion-cliente/ficha-valoracion-cliente.component';
import { ValoracionCliente } from 'src/app/home/_models/valoracion-cliente';


@Component({
  selector: 'app-valoracion-clientes',
  templateUrl: './valoracion-clientes.component.html',
  styleUrls: ['./valoracion-clientes.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    FichaValoracionClienteComponent
  ]
})


export class ValoracionClientesComponent implements OnInit
{

  public valoraciones: ValoracionCliente[] = [
    {
      colorTexto: "secondary-venture-800",
      bordeColor: "border-secondary-venture-800",
      bgCirculo: "bg-secondary-venture-200",
      siglas: "ML",
      imagenValoracion: "assets/assets/icons/icon-72x72.png",
      nombrePersona: "M. Lozano",
      textoValoracion: "Un placer haberos conocido, en especial a Javier M. por su dedicación y saber estar en todo momento. Muchas gracias por todo."
    },
    {
      colorTexto: "secondary-funds-800",
      bordeColor: "border-secondary-funds-800",
      bgCirculo: "bg-secondary-funds-200",
      siglas: "JC",
      imagenValoracion: "assets/assets/icons/icon-72x72.png",
      nombrePersona: "Juan Carlos Vera Zanotti",
      textoValoracion: "Amables, serios y dispuestos a explicar todas las dudas que se puedan tener."
    },
    {
      colorTexto: "secondary-factoring-800",
      bordeColor: "border-secondary-factoring-800",
      bgCirculo: "bg-secondary-factoring-300",
      siglas: "JK",
      imagenValoracion: "assets/assets/icons/icon-72x72.png",
      nombrePersona: "Jaime Kessier",
      textoValoracion: "Sin duda alguna lo mejor del sector. Enhorabuena por el buen trabajo y la gran profesionalidad. Un gusto."
    },
    {
      colorTexto: "secondary-estate-500",
      bordeColor: "border-secondary-estate-500",
      bgCirculo: "bg-secondary-estate-50",
      siglas: "FS",
      imagenValoracion: "assets/assets/icons/icon-72x72.png",
      nombrePersona: "Florentino Sanz García",
      textoValoracion: "Gran empresa, con gente seria, muy profesional y cualificada."
    },
    {
      colorTexto: "secondary-venture-800",
      bordeColor: "border-secondary-venture-800",
      bgCirculo: "bg-secondary-venture-200",
      siglas: "OS",
      imagenValoracion: "assets/assets/icons/icon-72x72.png",
      nombrePersona: "Octavio Sanz",
      textoValoracion: "Seriedad, rigor, y confianza. Un 10."
    },
  ]

  constructor()
  {
  }

  ngOnInit(): void
  {
    Swiper.use([Navigation, Pagination, Autoplay]);

    const swiper = new Swiper('.swiperValoracion', {
      // Default parameters
      slidesPerView: 1,
      spaceBetween: 10,
      // Pagination
      pagination: {
        el: '.swiper-valoracion-clientes',
        clickable: true
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      // Responsive breakpoints
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 25
        },
        554: {
          slidesPerView: 2,
          spaceBetween: 50
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 75
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 100
        }
      },
      navigation: true
    })
  }

}
